import {React,ReactDOM,moveWidget,extend,joinUrl,joinIfAbsent,insertStylesheetLink,insertScriptTag,
    addStylesMapper,setCustomTextProps,showModal,LEVEL_OVERLAY} from 'pexui';
import {GetInfoWidgetApp} from './views/main_widget';
import * as utils from './utilities/utils';
import {initTrack, trackError, setTrackOpts, track} from './utilities/track';
import {flow} from './models/flow';
import globals from './models/globals';

// move the widget to a new container
function moveTo(widget_view_id){
    var container = utils.getElement(widget_view_id);

    if(!container){
        throw new Error("Can't find the container");
    }

    if(flow.widget){
        moveWidget(flow.widget, container);
    }
}

function validateParams(widgetConfig, requestData, widgetCallback){
    // parameters validation
    if(typeof requestData.document_data !== 'object'){
        throw new Error("widget_request.document_data is required.");
    }
    // keep compatibility
    if(Array.isArray(requestData.document_data)){
        if(requestData.document_data.length !== 1){
            throw new Error("Only 1 document_data is supported.");
        }
        requestData.document_data = requestData.document_data[0];
    }
    if(typeof widgetCallback !== 'function'){
        throw new Error("widgetCallback function is required");
    }

    var displayMode = widgetConfig.display_mode || '';
    var container = null;

    var widgetID = widgetConfig.widget_view_id;
    if(widgetID){
        container = utils.getElement(widgetID);
        if(!container){
            throw new Error("Can not find an element (" + widgetID + ")");
        }
        if(typeof widgetID === 'object'){
            container = widgetID;
            // make it a string in order to pass the service-side validation
            widgetConfig.widget_view_id = container.getAttribute('id') || 'element_without_id';
        }
    }else{
        // create the container in 'overlay' mode
        widgetConfig.widget_view_id = "dummy_for_overlay";
        displayMode += (displayMode?'|':'') + 'OVERLAY|CAPTION';
    }

    // compatibility
    if(widgetConfig.invoker_styles && !widgetConfig.invoker_style_url){
        widgetConfig.invoker_style_url = widgetConfig.invoker_styles;
        delete widgetConfig.invoker_styles;
    }
    if(widgetConfig.invoker_prop && !widgetConfig.invoker_prop_url){
        widgetConfig.invoker_prop_url = widgetConfig.invoker_prop;
        delete widgetConfig.invoker_prop;
    }

    return {
        displayMode: displayMode,
        container: container
    };
}

var mainInvoked = false;

/**
 * Bootstrap the DocUploadWidget
 * @see https://enterprise-confluence.aexp.com/confluence/pages/viewpage.action?pageId=125838007
 * @param widgetConfig
 * widget_view_id: Indicates Layered/Embedded view of widget,
 *        supports "elem_id" | "#elem_id" | elem_obj | undefined (creates new root element)
 *        if "elem_id" | "#elem_id" is provided, the elem_id will be tried to find in the current document,
 *        if it's not found, a new div element with the elem_id will be generated.
 *        if widgetID is undefined, a new div element with the elem_id will be generated.
 * @param requestData
 * @param widgetCallback callback function
 * @return {object} an object containing move method
 */
function main(widgetConfig, requestData, widgetCallback){
    try{
        if(!document.createElement){

            const invokeOnce = function(){
                if(!mainInvoked){
                    mainInvoked = true;
                    main(widgetConfig, requestData, widgetCallback);
                }
            };

            //whichever runs first
            if(document.addEventListener){
                document.addEventListener('DOMContentLoaded', invokeOnce);
            }
            setTimeout(invokeOnce, 500);

            return;
        }

        utils.resetGlobals();

        const disp = validateParams(widgetConfig, requestData, widgetCallback);
        globals.displayMode = disp.displayMode;

        // do with themes
        if(disp.displayMode.indexOf('OVERLAY')>=0){
            showModal(<GetInfoWidgetApp config={widgetConfig} req={requestData} widgetCallback={widgetCallback}
                displayMode={disp.displayMode}
                />, LEVEL_OVERLAY);
        }else{
            ReactDOM.render( <GetInfoWidgetApp config={widgetConfig} req={requestData} widgetCallback={widgetCallback}
                displayMode={disp.displayMode}/>, disp.container);
        }

        return {
            moveTo: moveTo
        };
    }catch(err){
        utils.logError(err);

        track('Start:Error');
        trackError('error.service.message');

        if(typeof widgetCallback === 'function'){
            widgetCallback({
                event_name: 'fail',
                event_value: String(err)
            });
        }
    }
};

module.exports = main;



// WEBPACK FOOTER //
// ./application/src/app.js